import React, { PureComponent } from 'react';
import { Form } from 'antd';
import { language } from '../../../language';
import { services } from '@comall-backend-builder/core';
import {
    ColorPicker,
    EntryList,
    UploadPicture,
    FormItemLayout,
    ConfigFormDecorator,
} from '../../tools';
import { NoticeBarTips } from './notice-bar-tips';
import { NoticeBarItem } from './notice-bar-item';

const interpolate = services.interpolate;
const FormItem = Form.Item;
const MAX_ENTRY_COUNT = 10;
export class noticeBar extends PureComponent<any> {
    WrapNoticeItem = (props) => {
        const { selector } = this.props;
        return <NoticeBarItem key={props.index} {...props} selector={selector} />;
    };
    render() {
        const {
            form: { getFieldDecorator },
            sourceRoot,
            uploadAction,
            linkTypes,
            linkTypeMode,
        } = this.props;
        const formItemLayout = FormItemLayout;
        return (
            <Form className="editor-notice-bar">
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.NoticeBar.color')}
                >
                    {getFieldDecorator('fontColor')(<ColorPicker />)}
                </FormItem>
                <FormItem
                    {...formItemLayout}
                    label={language.getText('components.NoticeBar.backgroundColor')}
                >
                    {getFieldDecorator('backgroundColor')(<ColorPicker />)}
                </FormItem>
                <FormItem {...formItemLayout} label={language.getText('components.NoticeBar.icon')}>
                    <div>
                        {getFieldDecorator('leftIcon')(
                            <UploadPicture sourceRoot={sourceRoot} uploadAction={uploadAction} />
                        )}
                        <span>{language.getText('components.NoticeBar.imageSize')}</span>
                    </div>
                </FormItem>
                <FormItem>
                    {getFieldDecorator('entry', {
                        initialValue: [],
                    })(
                        <EntryList
                            linkTypes={linkTypes}
                            linkTypeMode={linkTypeMode}
                            maxCount={MAX_ENTRY_COUNT}
                            renderItem={this.WrapNoticeItem}
                            renderTips={NoticeBarTips}
                        />
                    )}
                </FormItem>
                <p className="entry-tip">
                    {interpolate(language.getText('components.NoticeBar.tips'), {
                        max: MAX_ENTRY_COUNT,
                    })}
                </p>
            </Form>
        );
    }
}
export const NoticeBar = ConfigFormDecorator(noticeBar);
